import {ComponentType, MouseEventHandler, SVGProps} from 'react';

export type ButtonProps = {
    id?: string,
    icon?: ComponentType<SVGProps<SVGSVGElement>>,
    iconProps?: SVGProps<SVGSVGElement>,
    label?: string
    type: 'secondary' | 'primary'
    error?: boolean,
    disabled?: boolean,
    className?: string,
    onClick: MouseEventHandler<HTMLButtonElement>
}

const Button = (props: ButtonProps) => {

    const clickEvent: MouseEventHandler<HTMLButtonElement> = (e) => {
        if (props.onClick && !props.disabled) {
            props.onClick(e);
        }
    };

    let className = props.className ? ` ${props.className}` : '';
    className += props.error ? ' is-invalid' : '';
    className += props.icon && !props.label ? ' dfb-Button--icon' : '';

    // disabled=false is not allowed
    const inactive = props.disabled ? true : undefined;

    return (
        <button className={`dfb-Button${className} dfb-Button--${props.type}`}
                type="button"
                disabled={inactive}
                onClick={clickEvent}
                id={props.id}
        >
            {
                props.label &&
                <span className="dfb-Button-label">{props.label}</span>
            }
            {
                props.icon &&
                <span className="dfb-Button-icon">
                    <props.icon {...props.iconProps}/>
                </span>
            }
        </button>
    );
};

Button.defaultProps = {
    error: false,
    disabled: false
};

export default Button;
